import "./RelatedProjectsPanel.css";

import { OrganisationTypeConstants } from "../../../../../../constants";
import { Button, Column, CursorDataGrid, Row } from "../../../../../../widget";
import { ApplyWorkflowTemplatePanel } from "../../workflow-template/components";
import { useRelatedProjectPanel } from "./useRelatedProjectsPanel";

interface RelatedProjectsPanelProps {
  workflowTemplateUuid?: string;
}

export const RelatedProjectsPanel = ({ workflowTemplateUuid }: RelatedProjectsPanelProps): JSX.Element => {
  const {
    onChange,
    workflowTemplate,
    showApplyWorkflowTemplatePanel,
    setShowApplyWorkflowTemplatePanel,
    columns,
    refresh,
    isLoading,
    relatedProjectsPanelRef,
    currentUserType,
  } = useRelatedProjectPanel({
    workflowTemplateUuid,
  });
  return (
    <div
      ref={relatedProjectsPanelRef}
      className={`RelatedProjectsPanel ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "Rounded" : ""}`}
    >
      <Row spacingV="ll">
        <Column span={6}>
          <h2>Related projects</h2>
        </Column>
        {workflowTemplateUuid && (
          <Column span={6} justify="end">
            <Button text="Apply workflow to project" onClick={() => setShowApplyWorkflowTemplatePanel(true)} />
          </Column>
        )}
      </Row>
      <Row>
        <Column span={12}>
          {workflowTemplateUuid ? (
            <CursorDataGrid
              data={[]}
              columns={columns}
              clientSide={false}
              onChange={onChange}
              filterable
              dataIsLoading={isLoading}
              noDataMessage="No related projects to display"
              refresh={refresh}
            />
          ) : (
            <p className="body1">Select a workflow to show related projects</p>
          )}
        </Column>
      </Row>
      {showApplyWorkflowTemplatePanel && (
        <ApplyWorkflowTemplatePanel
          workflowTemplate={workflowTemplate}
          workflowTemplateUuid={workflowTemplateUuid}
          show={showApplyWorkflowTemplatePanel}
          onClose={() => setShowApplyWorkflowTemplatePanel(false)}
        />
      )}
    </div>
  );
};
